import adminAxios from 'src/admin-axios';
import appAxios from 'src/app-axios';
import Constants from 'src/constants';

export const accountcontrol = {
    namespaced: true,
    state: {
        rolesAndPermissionsList: [],
        permissionsList: [],
        permissionCategoryList: [],
    },
    getters: {
        getRolesAndPermissionsList (state) {
            return state.rolesAndPermissionsList;
        },
        getPermissionList (state) {
            return state.permissionsList;
        },
        getPermissionCategoryList (state) {
            return state.permissionCategoryList;
        },
    },
    mutations: {
        setRolesAndPermissionsList (state, data) {
            state.rolesAndPermissionsList = data;
        },
        setPermissionsList (state, data) {
            state.permissionsList = data;
        },
        setPermissionCategoryList (state, data) {
            state.permissionCategoryList = data;
        },
    },
    actions: {
        async createNewRole ({ dispatch }, payload) {
            const url = '/roles';
            try {
              await adminAxios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the Role.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async createNewPermission ({ dispatch }, payload) {
            const url = '/permissions';
            try {
              await adminAxios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the Permission.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchRolesAndPermissionsList ({ dispatch, commit }) {
            const url = 'api/user-admin/roles';
            try {
                const details = await appAxios.get(url);
                commit('setRolesAndPermissionsList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your Roles and Permission list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },

        async fetchPermissionsList ({ dispatch, commit }) {
            const url = 'api/user-admin/permissions';
            try {
                const details = await appAxios.get(url);
                commit('setPermissionsList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your Permission list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async addPermissionsToRole ({ dispatch }, payload) {
            const url = `roles/${payload.role_id}/permissions`;
            try {
                await adminAxios.put(url, payload.permissions);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in assigining permissions.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchPermissionCategoryList ({ dispatch, commit }) {
            const url = 'api/user-admin/permissions/categories';
            try {
                const details = await appAxios.get(url);
                commit('setPermissionCategoryList', details.data.permission_categories);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting permission category list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
    },

};
